var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSlack = function SvgSlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#171717",
    d: "M14.25 3.9a1.35 1.35 0 0 1 1.35 1.35v4.5a1.35 1.35 0 1 1-2.7 0v-4.5a1.35 1.35 0 0 1 1.35-1.35m-9 9H6.6v1.35a1.35 1.35 0 1 1-1.35-1.35m7.65 4.5h1.35a1.35 1.35 0 1 1-1.35 1.35zm1.35-4.5h4.5a1.35 1.35 0 0 1 0 2.7h-4.5a1.35 1.35 0 1 1 0-2.7m4.5-4.5a1.35 1.35 0 0 1 0 2.7H17.4V9.75a1.35 1.35 0 0 1 1.35-1.35m-13.5 0h4.5a1.35 1.35 0 0 1 0 2.7h-4.5a1.35 1.35 0 1 1 0-2.7m4.5-4.5a1.35 1.35 0 0 1 1.35 1.35V6.6H9.75a1.35 1.35 0 1 1 0-2.7m0 9a1.35 1.35 0 0 1 1.35 1.35v4.5a1.35 1.35 0 1 1-2.7 0v-4.5a1.35 1.35 0 0 1 1.35-1.35"
  })));
};
export default SvgSlack;